import { I18n } from '../../wrappers';
export class OrderItemLocalizationMe {
    orderItem;
    constructor(orderItem) {
        this.orderItem = orderItem;
    }
    static exemptFromTaxReasons() {
        const reasonLabel = (reason) => {
            return I18n.t(`order.exempt_from_tax_reason.${reason.code}`);
        };
        let reasons = [
            { code: 'VAT_CL17', category: null },
            { code: 'VAT_CL20', category: null },
            { code: 'VAT_CL26', category: null },
            { code: 'VAT_CL27', category: null },
            { code: 'VAT_CL28', category: null },
            { code: 'VAT_CL29', category: null },
            { code: 'VAT_CL30', category: null },
            { code: 'VAT_CL44', category: null },
        ];
        return reasons.map(r => {
            r.label = reasonLabel(r);
            return r;
        });
    }
}
const OrderItemLocalizationMeStatic = OrderItemLocalizationMe;
//# sourceMappingURL=OrderItemLocalizationMe.js.map